import { absolute } from './absolute';
import { dollar } from './dollar';
import { fixed } from './fixed';
import { phone } from './phone';

export default [
	{ 'name': 'absolute', 'action': absolute },
	{ 'name': 'dollar', 'action': dollar },
	{ 'name': 'fixed', 'action': fixed },
	{ 'name': 'phone', 'action': phone }
]
